
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock } from 'lucide-react';
import { format } from 'date-fns';

interface SOSEventsTabProps {
  sosEvents: any[];
}

const SOSEventsTab = ({ sosEvents }: SOSEventsTabProps) => {
  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>SOS Events</CardTitle>
        <CardDescription>
          When you've used the SOS button to help with cravings
        </CardDescription>
      </CardHeader>
      <CardContent>
        {sosEvents.length === 0 ? (
          <p className="text-center py-6 text-gray-500">You haven't used the SOS button yet</p>
        ) : (
          <div className="space-y-4">
            {sosEvents.map((event) => (
              <div key={event.id} className="flex items-center border-b border-gray-100 pb-4">
                <div className="bg-coral w-2 h-2 rounded-full mr-3"></div>
                <div className="flex items-center text-sm">
                  <Calendar className="h-3 w-3 mr-1" />
                  <span>{format(new Date(event.created_at), 'PPP')}</span>
                  <Clock className="h-3 w-3 ml-3 mr-1" />
                  <span>{format(new Date(event.created_at), 'p')}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SOSEventsTab;
